import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface VehicleInfo {
  ktype: number;
  manufacturer: string;
  model: string;
  cartype: string;
  from_year: number;
  to_year?: number;
  fueltype?: string;
  ccm?: number;
  hp?: number;
}

export interface VehicleHistoryEntry {
  vehicle: VehicleInfo;
  plate: string | null;
}

interface VehicleStore {
  vehicle: VehicleInfo | null;
  plate: string | null;
  vehicleId: number | null; // business_vehicle_id for chat context
  history: VehicleHistoryEntry[];
  setVehicle: (vehicle: VehicleInfo, plate?: string, vehicleId?: number) => void;
  clearVehicle: () => void;
  selectFromHistory: (ktype: number) => void;
  removeFromHistory: (ktype: number) => void;
}

const MAX_HISTORY = 5;

export const useVehicleStore = create<VehicleStore>()(
  persist(
    (set, get) => ({
      vehicle: null,
      plate: null,
      vehicleId: null,
      history: [],

      setVehicle: (vehicle, plate, vehicleId) => {
        const state = get();
        // Add to history (dedup by ktype, most recent first)
        const filtered = state.history.filter(h => h.vehicle.ktype !== vehicle.ktype);
        const history = [{ vehicle, plate: plate || null }, ...filtered].slice(0, MAX_HISTORY);
        set({ vehicle, plate: plate || null, vehicleId: vehicleId || null, history });
      },

      clearVehicle: () => {
        set({ vehicle: null, plate: null, vehicleId: null });
      },

      selectFromHistory: (ktype: number) => {
        const entry = get().history.find(h => h.vehicle.ktype === ktype);
        if (entry) {
          // Move to front of history
          const filtered = get().history.filter(h => h.vehicle.ktype !== ktype);
          const history = [entry, ...filtered];
          set({ vehicle: entry.vehicle, plate: entry.plate, history });
        }
      },

      removeFromHistory: (ktype: number) => {
        const state = get();
        const history = state.history.filter(h => h.vehicle.ktype !== ktype);
        const isCurrent = state.vehicle?.ktype === ktype;
        set({
          history,
          ...(isCurrent ? { vehicle: null, plate: null } : {}),
        });
      },
    }),
    {
      name: 'autofrance-current-vehicle',
    }
  )
);
